import { render, staticRenderFns } from "./ChatsPage.vue?vue&type=template&id=7ed01856&scoped=true"
import script from "./ChatsPage.vue?vue&type=script&lang=js"
export * from "./ChatsPage.vue?vue&type=script&lang=js"
import style0 from "./ChatsPage.vue?vue&type=style&index=0&id=7ed01856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed01856",
  null
  
)

export default component.exports